module.exports = __webpack_public_path__ + "img/DP011E_001.99aaf0c3.png";